<template>
    <span ref="modal" @hidden="doNothing" @hide="doNothing" @ok="doNothing" @shown="doNothing"></span>
</template>

<script>
    import mbModalLoader from "@dialogs/modalLoader";

    export default {
        mixins: [mbModalLoader],
        methods: {
            onMounted() {},
            hide(e) {
                this.doNothing();
            },
            close(mode = -1) {
                this.doNothing();
            },
            open(data = { title: "Title", body: "<p>Message</p>" }) {
                this.doNothing();
            },
            doNothing() {}
        }
    };
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/custom/mbstalas/dialogs/modalLoader.vue